import React from 'react';

interface HomeMainContentProps {
  scrollViewRef?: React.RefObject<any>;
  scrollY?: number;
}

const HomeHotBanner =
  require('@/pages/home/v2/components/home-hot-banner').default;
const HomeV2 = require('@/pages/home/v2/home').default;

export const SharedHomeHotBanner = HomeHotBanner;

const HomeMainContent = ({scrollViewRef, scrollY}: HomeMainContentProps) => {
  return <HomeV2 scrollViewRef={scrollViewRef} scrollY={scrollY} />;
};

export default HomeMainContent;
